!function(window) {
function addRemoveNodesFunctionality(options) {

	function toggleView() {
		var activeNumber = options.html.tree.tableWrapper.find('tbody>tr.active').length;
		if (activeNumber) {
			showView();
		} else {
			hideView();
		}
	}
	function showView() {
		// show hides view
		$('.section-wrapper.stacked-area-chart,.section-wrapper.tree-map .chart-wrapper, .back-in-graf').fadeIn();

	}
	function hideView() {
		$('.section-wrapper.stacked-area-chart,.section-wrapper.tree-map .chart-wrapper, .back-in-graf').fadeOut();
	}
	$('.iopr-data-wrapper').on('click', '.toggle-select', function(ev) {
		
		if (options.methods.isProcessing()) {
			return;
		}
		
		var type = $(this).attr('data-type');
		if (options.html.tree.tableWrapper) {
			options.html.tree.tableWrapper.find('tbody tr').each(function(index, item) {
				var $tr = $(item);
				var id = $tr.attr('data-id');
				switch (type) {
					case 'select':
						addNodeToTree($tr, id);
					break;
					case 'unselect':
						removeNodeFromTree($tr, id);
					break;
				}
			});
			switch (type) {
				case 'select':
					showView();
					break;
				case 'unselect':
					hideView();
					break;
			}
			createDataFromSelectedValues();

		}
		
	});

	$('.iopr-data-wrapper').on('click', '.chart-manipulation-toggle', function (ev) {
		
		ev.stopPropagation();


		if (options.methods.isProcessing()) {
			return;
		}

		// get table row
		var $tr = $(this).closest('tr');
		var id = $tr.attr('data-id');

		// indicator if its included in chart is by the class name
		var isActive = $tr.hasClass('active');
		
		// if to use confirm to add/remove rows
		if (options.properties.useConfirm) {
			var textSelector = isActive ? 'data-remove' : 'data-add';
			//set modal title / content and show modal
			var modalTitleWrapper = options.elements.tableModal.find('.modal-title');
			var modalContentWrapper = options.elements.tableModal.find('.modal-body');
			modalTitleWrapper.text(modalTitleWrapper.attr(textSelector));
			modalContentWrapper.text(modalContentWrapper.attr(textSelector));

			modalConfirm(function (res) {
				if (res) {
					if (isActive) {
						removeNodeFromTree($tr, id);
					} else {
						addNodeToTree($tr, id);
					}
					toggleView();
					createDataFromSelectedValues();
				}
			});
		} else {
			if (isActive) {
				removeNodeFromTree($tr, id);
			} else {
				addNodeToTree($tr, id);
			}
			toggleView();
			createDataFromSelectedValues();
		}
	});

	// function that handles dialog yes/no
	function modalConfirm(cb) {

		var confirmed = false;
		options.elements.tableModal.modal('show');

		options.elements.tableModal.find('[data-accept]').one('click', function (ev) {
			confirmed = true;
			cb(true);
			options.elements.tableModal.modal('hide');
		});

		// when modal is hidden then its rejected
		// return only if it wasnt accepted before
		options.elements.tableModal.one('hide.bs.modal', function (ev) {
			if (!confirmed) {
				cb(false);
			}
			options.elements.tableModal.find('[data-accept]').off('click');
		});

	}

	// removes from the chart view 
	// and redraws the chart at the current location if possible
	function removeNodeFromTree($tr, id) {



		makeTrAndItsChildrenInactive($tr);

		// make trs inactive
		function makeTrAndItsChildrenInactive($tr) {

			var id = $tr.attr('data-id');
			if ($tr.hasClass('active')) {
				$tr.removeClass('active');
				$tr.addClass('inactive');
			}

			// next == sibling
			var $childrenWrapper = $tr.next('.tr-children-wrapper');
			if ($childrenWrapper.length) {
				var $elements = $childrenWrapper.find('.value-row[data-parent-id="' + id + '"]');
				$elements.each(function (i, item) {
					var $trChild = $(item);
					makeTrAndItsChildrenInactive($trChild);
				});
			}
		}
	}

	function addNodeToTree($tr, id) {

		makeTrAndItsParentsActive($tr);

		// after je bil sitn je bilo dodano
		makeTrAndItsChildrenActive($tr);

		function makeTrAndItsParentsActive($tr) {
			var parentid = $tr.attr('data-parent-id');
			if ($tr.hasClass('inactive')) {
				$tr.removeClass('inactive');
				$tr.addClass('active');
			}

			if (parentid) {
				var $parentTr = $('.value-row[data-id="'+parentid+'"]');
				makeTrAndItsParentsActive($parentTr);
			}
		}	
	
		function makeTrAndItsChildrenActive($tr) {
			var id = $tr.attr('data-id');
			if ($tr.hasClass('inactive')) {
				$tr.removeClass('inactive');
				$tr.addClass('active');
			}

			// next == sibling
			var $childrenWrapper = $tr.next('.tr-children-wrapper');
			if ($childrenWrapper.length) {
				var $elements = $childrenWrapper.find('.value-row[data-parent-id="' + id + '"]');
				$elements.each(function (i, item) {
					var $trChild = $(item);
					makeTrAndItsChildrenActive($trChild);
				});
			}
		}
	}

	function createDataFromSelectedValues() {

		var inactiveTrs = [];
		$('.value-row.inactive').each(function(i, item) {
			inactiveTrs.push($(item).attr('data-id'));
		});
		
		options.properties.excluded = inactiveTrs;
		
		// for google cahrts just exclude those that were removed
		// and place it under current with is there to display data
		switch (options.properties.chartType) {
			case 'google-charts':
				setCurrentDataForTreemapGoogleCharts();
			break;
			case 'e-charts':
				setCurrentDataForTreemapEcharts();
			break;
		}
		

		options.charts.tree.generate(true);

		// for echart stackedarea wee need to save excluided
		// and when we are setting series we check if it was excluded
		// inside javascript

		if (options.charts.stackedArea.chart) {
			options.charts.stackedArea.generate();
		}


		// google is a single depth array
		function setCurrentDataForTreemapGoogleCharts () {
			options.data.tree.currentData = options.data.tree.baseData.filter((i) => {
				if (i[1] == 'parent' || i[1] == null) {
					return i;
				}
				return inactiveTrs.indexOf(i[0].v) === -1;
			});
		}

		// need to remote data recursive because its a nested structure
		function setCurrentDataForTreemapEcharts() {
			if (options.properties.chartType == 'google-charts') {

			} else if (options.properties.chartType == 'e-charts') {

			}

			const current = [];
			for (const node of options.data.tree.baseData) {
				const filtered = currentDataRecursive(node);
				if (filtered) {
					current.push(filtered);
				}
			}
			
			options.data.tree.currentData = current;

			function currentDataRecursive(node) {
				if (options.properties.excluded.indexOf(node.id) != -1) {
					return null;
				}
				// create new because we will filter its children aswell
				// and we need to keep base list of data for further filters
				// if necessary
				const nodeCopy = {
					id: node.id,
					name: node.name,
					value: node.value
				}
				if (node.children && node.children.length) {
					nodeCopy.children = [];
					for (const child of node.children) {
						const filteredChild = currentDataRecursive(child);
						if (filteredChild) {
							nodeCopy.children.push(filteredChild);
						}
					}

				}
				return nodeCopy;
			}
		}
	}

}

module.exports = addRemoveNodesFunctionality;
window.addRemoveNodesFunctionality = addRemoveNodesFunctionality;
}.call(window, window);